<ng-template *ngIf="src?.length">
  {{ src }}
</ng-template>
